export default "__VITE_ASSET__3a64d7ce__"